<template>
  <card title="Canal de Denúncia">
    <template slot="content">
      <div class="row">
        <div class="col-md-12">
          <h3>Formalize aqui a sua denúncia</h3>
          <p>
            Este espaço é reservado para que você formalize a sua denúncia junto
            à área de Compliance, de forma anônima ou identificada. Preencha
            todos os campos obrigatórios para que seja possível concluir a sua
            denúncia. Opte pela opção anônima caso você não queira ser
            identificado. Em qualquer hipótese, são assegurados o sigilo e a não
            retaliação.
          </p>
          <p>
            A denúncia é um procedimento sério, que deve ser adotado com boa-fé,
            consciência e responsabilidade. Jamais utilize o canal de denúncias
            de forma imotivada, com a finalidade de prejudicar ou expor alguém.
            Caso tenha dúvidas em relação ao procedimento que será adotado,
            consulte a
            <a
              href="https://compliance.meta.com.br/wp-content/uploads/2023/11/meta_politica_de_apuracao_de_denuncias.pdf"
              target="_blank"
            >
              Política de Apuração de Denúncias</a
            >.
          </p>
          <p>
            Lembre-se de detalhar ao máximo o ato ou fato objeto da denúncia
            para que a sua apuração possa se dar da forma mais ampla e
            verossímil possível, especificando, dentre outros, qual a violação
            ou potencial violação; como e quantas vezes ocorreu; local e data de
            ocorrência; pessoas envolvidas; eventuais provas existentes; e
            testemunhas do ato/fato. Ao enviar sua denúncia você receberá um
            número de protocolo para acompanhamento e direcionado à respectiva
            página.
          </p>
          <p>
            Os dados pessoais eventualmente fornecidos da denúncia identificada
            serão tratados para o cumprimento de obrigação legal, especialmente
            a Lei anticorrupção (Lei 12.486/2013), dispensando, assim, o
            consentimento do titular dos dados. Para saber mais sobre o
            tratamento que daremos aos dados pessoais e quais dados serão
            coletados na denúncia identificada acesse nossa
            <a
              href="https://www.meta.com.br/politica-de-privacidade/"
              target="_blank"
              >Política de Privacidade</a
            >.
          </p>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-12">
          <form id="myForm" enctype="multipart/form-data">
            <div class="row">
              <div
                id="identification-option"
                class="col-sm-12 col-md-12 col-lg-12"
              >
                <input
                  type="radio"
                  id="identified"
                  name="identification-option"
                  value="identified"
                  v-model="identification_option"
                />
                <label for="identified">Denúncia identificada</label><br />
                <input
                  type="radio"
                  id="anonymous"
                  name="identification-option"
                  value="anonymous"
                  v-model="identification_option"
                />
                <label for="anonymous">Denúncia anônima</label><br />
              </div>
              <div id="identification-area" v-if="cShowIdentificationFields">
                <div class="col-sm-9 col-md-9 col-lg-9">
                  <meta-text
                    class="label"
                    id="nome-c"
                    name="nome"
                    label="Nome"
                    v-model="formulario.nome"
                    :required="cShowIdentificationFields"
                    placeholder="Nome Sobrenome"
                  ></meta-text>
                </div>

                <div class="col-sm-3 col-md-3 col-lg-3">
                  <meta-text
                    class="label"
                    id="data-nascimento-c"
                    name="data-nascimento"
                    label="Data de Nascimento"
                    v-model="formulario.data_nascimento"
                    :required="cShowIdentificationFields"
                    placeholder="dd/mm/aaaa"
                    v-mask="'##/##/####'"
                  />
                </div>

                <div class="col-sm-6 col-md-6 col-lg-6">
                  <meta-email
                    class="label"
                    id="email-c"
                    name="email"
                    label="E-mail"
                    v-model="formulario.email"
                    :required="cShowIdentificationFields"
                    placeholder="exemplo@email.com"
                  ></meta-email>
                </div>

                <div class="col-sm-6 col-md-6 col-lg-6">
                  <meta-phone
                    class="label"
                    id="phone-c"
                    name="phone"
                    label="Número de Telefone"
                    v-model="formulario.phone"
                    :required="cShowIdentificationFields"
                    placeholder="(00) 00000-0000"
                  ></meta-phone>
                </div>
              </div>

              <div class="form-group col-sm-12 col-md-12 col-lg-12">
                <meta-select
                  class="label"
                  id="relacao"
                  label="Qual sua Relação com a Meta?"
                  name="relacao"
                  v-model="formulario.relacao"
                  attr-id="id"
                  attr-label="relacao"
                  :options="relacoes"
                  placeholder="Selecione..."
                  deselect-label="Remover"
                  select-label="Selecionar"
                  required
                ></meta-select>
              </div>

              <div class="form-group col-sm-12 col-md-12 col-lg-12">
                <label class="label required-label" for="descricao"
                  >Descrição</label
                >
                <textarea
                  class="form-control vertical"
                  rows="6"
                  minlength="200"
                  id="descricao"
                  name="Descrição"
                  v-model="formulario.descricao"
                  v-validate="{ required: true, min: 200 }"
                  placeholder="Mínimo de 200 caracteres"
                ></textarea>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-2">
                    <label class="btn btn-primary btn-block" for="files"
                      >Inserir Anexos</label
                    >
                    <input
                      type="file"
                      id="files"
                      ref="files"
                      multiple
                      v-on:change="adicionaArquivoLista()"
                    />
                    <small class="text-muted">Campo opcional</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div
                      v-for="(file, key) in formulario.files"
                      :key="file.key"
                      class="file-listing"
                    >
                      <div class="row" style="padding-left: 15px">
                        <div class="col-md-12">
                          <a
                            class="remove-file"
                            v-on:click="removeArquivo(key)"
                          >
                            <i class="fa fa-times"></i>
                          </a>
                          {{ file.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>Tamanho máximo permitido: 5mb</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="row justify-content-between">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-7 flex">
                        <input
                          type="checkbox"
                          id="politica"
                          name="politica"
                          v-model="formulario.aceitou_politica"
                        />
                        <span>
                          “Estou de acordo com a
                          <a
                            href="https://www.meta.com.br/politica-de-privacidade/"
                            target="_blank"
                          >
                            Política de Privacidade
                          </a>
                          e ciente de que os dados pessoais são tratados nas
                          denúncias pela META para o cumprimento de obrigação
                          legal”.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-12">
                  <div class="row justify-content-between">
                    <div class="col-md-10"></div>

                    <div class="col-md-2">
                      <button
                        class="btn btn-success btn-block"
                        type="submit"
                        @click.prevent="enviarFormulario()"
                      >
                        Enviar
                      </button>
                    </div>
                    <div class="col-md-2">
                      <vue-recaptcha
                        ref="recaptcha"
                        :sitekey="$root.siteKeyReCaptcha"
                        size="invisible"
                        @verify="onCaptchaVerified"
                        @expired="onCaptchaExpired"
                      >
                      </vue-recaptcha>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </template>
  </card>
</template>

<style lang="scss">
#nome-c,
#phone-c,
#email-c,
#data-nascimento-c {
  height: 40px !important;
}

#identification-option {
  margin-top: 10px;
}

input[type="file"] {
  display: none !important;
}

a.remove-file {
  color: rgb(209, 0, 0);
  cursor: pointer;
}

span.help {
  display: none;
}

.has-error .control-label {
  color: #142260 !important;
}

.flex {
  display: flex;
}

#politica {
  margin-right: 10px;
}
</style>

<script>
import MetaText from "meta-text";
import MetaSelect from "meta-select";
import MetaModal from "meta-modal";
import MetaPhone from "meta-input-phone";
import MetaEmail from "meta-email";
import Card from "./templates/Card.vue";
import Utils from "@/mixins/utils.js";
import RemoverAcentos from "@/mixins/removerAcentos.js";
import VueRecaptcha from "vue-recaptcha";
import { mask } from "vue-the-mask";

export default {
  name: "CanalDenuncias",

  directives: { mask },

  components: {
    MetaText,
    MetaSelect,
    MetaModal,
    Card,
    MetaPhone,
    MetaEmail,
    VueRecaptcha
  },

  mixins: [Utils, RemoverAcentos],

  data() {
    return {
      relacoes: [],
      isDadosInseridosSaoValidos: false,
      ischecarSeProtocoloFoiAnotado: false,
      protocolo: "",
      tam_maximo: 5000000,
      tamanho_atual: 0,
      identification_option: "identified",
      formulario: {
        files: [],
        nome: "",
        data_nascimento: "",
        email: "",
        phone: "",
        relacao: "",
        descricao: "",
        aceitou_politica: false
      }
    };
  },

  mounted() {
    this.inicializarRecaptcha();
    this.carregamentoRelacoes();
  },

  computed: {
    cNome() {
      if (!this.formulario.nome) {
        return null;
      }

      return this.formulario.nome;
    },

    cRelacao() {
      if (!this.formulario.relacao) {
        return null;
      }

      return this.formulario.relacao.id;
    },

    cShowIdentificationFields() {
      return this.identification_option === "identified";
    }
  },

  methods: {
    validarCampos() {
      if (!this.formulario.aceitou_politica) {
        this.customAlert(
          "Atenção!",
          "Você precisa aceitar a Politica de Privacidade para continuar.",
          "warning"
        );
        return false;
      }

      if (
        !!this.formulario.descricao &&
        this.formulario.descricao.length >= 200 &&
        !!this.formulario.relacao &&
        this.$validator.validateAll()
      ) {
        return true;
      }

      if (
        !!this.formulario.descricao &&
        this.formulario.descricao.length < 200
      ) {
        this.customAlert(
          "Atenção!",
          "O campo de descrição deve conter no mínimo 200 caracteres.",
          "warning"
        );
        return false;
      }

      this.customAlert(
        "Atenção!",
        "Por favor, preencha todos os campos.",
        "warning"
      );

      return false;
    },

    enviarFormulario() {
      this.$refs.recaptcha.execute();
    },

    async onCaptchaVerified(recaptchaToken) {
      try {
        this.$parent.loading = true;

        if (!this.validarCampos()) {
          this.$parent.loading = false;
          this.$refs.recaptcha.reset();
          return false;
        }

        const formData = new FormData();
        formData.append("criado_por", this.formulario.nome);
        formData.append("relacao_id", this.formulario.relacao.id);
        formData.append("descricao", this.formulario.descricao);
        formData.append("data_nascimento", this.formulario.data_nascimento);
        formData.append("phone", this.formulario.phone);
        formData.append("email", this.formulario.email);
        formData.append("aceitou_politica", this.formulario.aceitou_politica);
        formData.append("recaptchaToken", recaptchaToken);

        const arquivos = this.formulario.files;

        for (let i = 0; i < arquivos.length; i++) {
          formData.append(
            "files[]",
            arquivos[i],
            this.removerAcentos(arquivos[i].name)
          );
        }

        const { data: response } = await this.$http.post(
          "/denuncias",
          formData
        );

        if (response.success === false) {
          throw new Error(response.message);
        }

        this.protocolo = response.protocolo;

        return swal({
          title: "Denúncia enviada com sucesso!",
          text: `Anote seu número de protocolo: ${response.protocolo}`,
          icon: "success"
        }).then(this.encaminharParaConsultaPorProtocolo);
      } catch (e) {
        return this.customAlert(
          "Ocorreu um erro!",
          "Entre em contato com o administrador do sistema.",
          "error"
        );
      } finally {
        this.$parent.loading = false;
      }
    },

    encaminharParaConsultaPorProtocolo() {
      this.$router.push({ path: `/denuncia/acompanhamento/${this.protocolo}` });
    },

    async carregamentoRelacoes() {
      try {
        this.$parent.loading = true;

        const { data: response } = await this.$http.get(
          "/relacoes?sort=relacao|asc"
        );

        this.relacoes = response;
      } catch (e) {
        return this.customAlert(
          "Ocorreu um erro!",
          "Entre em contato com o administrador do sistema",
          "error"
        );
      } finally {
        this.$parent.loading = false;
      }
    },

    adicionaArquivoLista() {
      let uploadedFiles = this.$refs.files.files;

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.tamanho_atual += uploadedFiles[i].size;

        if (this.tamanho_atual > this.tam_maximo) {
          this.tamanho_atual -= uploadedFiles[i].size;
          this.customAlert(
            "Atenção!",
            "Os arquivos excederam o tamanho máximo permitido.",
            "warning"
          );
          return;
        }

        this.formulario.files.push(uploadedFiles[i]);
      }
    },

    removeArquivo(key) {
      this.tamanho_atual -= this.formulario.files[key].size;
      this.formulario.files.splice(key, 1);
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },

    inicializarRecaptcha() {
      let recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit"
      );
      document.head.appendChild(recaptchaScript);
      document.getElementById("nome-c").focus();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CanalDenuncias.vue